import React from 'react';

const ProgramsForm = ({ formData, setFormData }) => {

  const categories = [
    'Foundations', 'Productivity & Automation', 'Leadership & Strategy', 
    'Governance & Compliance', 'Business Growth', 'Security & Ethics', 
    'Trends & Innovation', 'Education', 'Healthcare'
  ];

return (
    <div className="space-y-6">
      {/* Basic Information Section */}
      <div className="bg-gray-50 p-6 rounded-lg">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Basic Information</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Program Title *
            </label>
            <input
              type="text"
              placeholder="Enter program title"
              value={formData.title || ''}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
              required
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Subtitle
            </label>
            <input
              type="text"
              placeholder="Enter program subtitle"
              value={formData.subtitle || ''}
              onChange={(e) => setFormData({ ...formData, subtitle: e.target.value })}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Slug
            </label>
            <input
              type="text"
              placeholder="program-slug"
              value={formData.slug || ''}
              onChange={(e) => setFormData({ ...formData, slug: e.target.value })}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Duration
            </label>
            <input
              type="text"
              placeholder="e.g., 12 weeks"
              value={formData.duration || ''}
              onChange={(e) => setFormData({ ...formData, duration: e.target.value })}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Format
            </label>
            <input
              type="text"
              placeholder="e.g., Online, Hybrid, In-person"
              value={formData.format || ''}
              onChange={(e) => setFormData({ ...formData, format: e.target.value })}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Price
            </label>
            <input
              type="text"
              placeholder="e.g., $2999"
              value={formData.price || ''}
              onChange={(e) => setFormData({ ...formData, price: e.target.value })}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>
        </div>
      </div>

      {/* Status and Scheduling Section */}
      <div className="bg-gray-50 p-6 rounded-lg">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Status & Scheduling</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Status *
            </label>
            <select
              value={formData.status || 'Open'}
              onChange={(e) => setFormData({ ...formData, status: e.target.value })}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            >
              <option value="Open">Open</option>
              <option value="Closed">Closed</option>
              <option value="Coming Soon">Coming Soon</option>
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Next Cohort
            </label>
            <input
              type="text"
              placeholder="e.g., January 2025"
              value={formData.nextCohort || ''}
              onChange={(e) => setFormData({ ...formData, nextCohort: e.target.value })}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>
          
          <div className="md:col-span-2">
            <label className="flex items-center space-x-2">
              <input
                type="checkbox"
                checked={formData.featured || false}
                onChange={(e) => setFormData({ ...formData, featured: e.target.checked })}
                className="w-4 h-4 text-indigo-600 bg-gray-100 border-gray-300 rounded focus:ring-indigo-500"
              />
              <span className="text-sm font-medium text-gray-700">Featured Program</span>
            </label>
          </div>
        </div>
      </div>

      {/* Categories Section */}
      <div className="bg-gray-50 p-6 rounded-lg">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Category *
        </label>
        
        {/* Dropdown to add categories */}
        <select
            value=""
            onChange={(e) => {
            if (e.target.value && !(formData.categories || []).includes(e.target.value)) {
                const updatedCategories = [...(formData.categories || []), e.target.value];
                setFormData({ ...formData, categories: updatedCategories });
            }
            e.target.value = ""; // Reset dropdown
            }}
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
        >
            <option value="">Add a category...</option>
            {categories
            .filter(cat => !(formData.categories || []).includes(cat))
            .map(cat => (
                <option key={cat} value={cat}>{cat}</option>
            ))}
        </select>
        {/* Selected tags */}
        {formData.categories && formData.categories.length > 0 && (
            <div className="flex flex-wrap gap-2 mt-2">
            {formData.categories.map(cat => (
                <span key={cat} className="inline-flex items-center px-3 py-1 bg-indigo-100 text-indigo-800 text-sm rounded-full">
                {cat}
                <button
                    type="button"
                    onClick={() => {
                    const updatedCategories = formData.categories.filter(c => c !== cat);
                    setFormData({ ...formData, categories: updatedCategories });
                    }}
                    className="ml-2 text-indigo-600 hover:text-indigo-800"
                >
                    ×
                </button>
                </span>
            ))}
            </div>
        )}
      </div>
      {/* Description Section */}
      <div className="bg-gray-50 p-6 rounded-lg">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Description & Details</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Description *
            </label>
            <textarea
              placeholder="Enter program description"
              value={formData.description || ''}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors h-32 resize-vertical"
              required
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Target Audience
            </label>
            <textarea
              placeholder="Who is this program for?"
              value={formData.target || ''}
              onChange={(e) => setFormData({ ...formData, target: e.target.value })}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors h-24 resize-vertical"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Prerequisites
            </label>
            <textarea
              placeholder="What are the prerequisites for this program?"
              value={formData.prerequisites || ''}
              onChange={(e) => setFormData({ ...formData, prerequisites: e.target.value })}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors h-24 resize-vertical"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Certification Details
            </label>
            <textarea
              placeholder="What certification will participants receive?"
              value={formData.certification || ''}
              onChange={(e) => setFormData({ ...formData, certification: e.target.value })}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors h-24 resize-vertical"
            />
          </div>
        </div>
      </div>

      {/* Media Section */}
      <div className="bg-gray-50 p-6 rounded-lg">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Media</h3>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Image URL
          </label>
          <input
            type="url"
            placeholder="https://example.com/image.jpg"
            value={formData.image || ''}
            onChange={(e) => setFormData({ ...formData, image: e.target.value })}
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
          />
        </div>
      </div>

      {/* Languages Section */}
      <div className="bg-gray-50 p-6 rounded-lg">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Languages</h3>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Available Languages (comma-separated)
          </label>
          <input
            type="text"
            placeholder="English, Spanish, French"
            value={formData.languages?.join(', ') || ''}
            onChange={(e) => setFormData({ 
              ...formData, 
              languages: e.target.value.split(',').map(lang => lang.trim()).filter(lang => lang)
            })}
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
          />
        </div>
      </div>

      {/* Outcomes Section */}
      <div className="bg-gray-50 p-6 rounded-lg">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Learning Outcomes</h3>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Outcomes (one per line)
          </label>
          <textarea
            placeholder="Outcome 1&#10;Outcome 2&#10;Outcome 3"
            value={formData.outcomes?.join('\n') || ''}
            onChange={(e) => setFormData({ 
              ...formData, 
              outcomes: e.target.value.split('\n').map(outcome => outcome.trim()).filter(outcome => outcome)
            })}
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors h-32 resize-vertical"
          />
          <p className="text-xs text-gray-500 mt-1">Enter each outcome on a new line</p>
        </div>
      </div>

      {/* Modules Section */}
      <div className="bg-gray-50 p-6 rounded-lg">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Program Modules</h3>
        <div className="space-y-4">
          {(formData.modules || []).map((module, index) => (
            <div key={index} className="bg-white p-4 rounded-lg border border-gray-200">
              <div className="flex justify-between items-center mb-3">
                <h4 className="font-medium text-gray-800">Module {index + 1}</h4>
                <button
                  type="button"
                  onClick={() => {
                    const updatedModules = formData.modules.filter((_, i) => i !== index);
                    setFormData({ ...formData, modules: updatedModules });
                  }}
                  className="text-red-600 hover:text-red-800 text-sm"
                >
                  Remove
                </button>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                <input
                  type="text"
                  placeholder="Module Title"
                  value={module.title || ''}
                  onChange={(e) => {
                    const updatedModules = [...formData.modules];
                    updatedModules[index] = { ...module, title: e.target.value };
                    setFormData({ ...formData, modules: updatedModules });
                  }}
                  className="w-full p-2 border border-gray-300 rounded focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                />
                
                <input
                  type="text"
                  placeholder="Duration"
                  value={module.duration || ''}
                  onChange={(e) => {
                    const updatedModules = [...formData.modules];
                    updatedModules[index] = { ...module, duration: e.target.value };
                    setFormData({ ...formData, modules: updatedModules });
                  }}
                  className="w-full p-2 border border-gray-300 rounded focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>
              
              <textarea
                placeholder="What You'll Learn Overview"
                value={module.whatYoullLearn?.overview || ''}
                onChange={(e) => {
                  const updatedModules = [...formData.modules];
                  updatedModules[index] = { 
                    ...module, 
                    whatYoullLearn: { 
                      ...(module.whatYoullLearn || {}), 
                      overview: e.target.value 
                    }
                  };
                  setFormData({ ...formData, modules: updatedModules });
                }}
                className="w-full p-2 border border-gray-300 rounded focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 h-20 resize-vertical mb-2"
              />
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">
                    Objectives (one per line)
                  </label>
                  <textarea
                    placeholder="Objective 1&#10;Objective 2"
                    value={module.whatYoullLearn?.objectives?.join('\n') || ''}
                    onChange={(e) => {
                      const updatedModules = [...formData.modules];
                      updatedModules[index] = { 
                        ...module, 
                        whatYoullLearn: { 
                          ...(module.whatYoullLearn || {}), 
                          objectives: e.target.value.split('\n').map(obj => obj.trim()).filter(obj => obj)
                        }
                      };
                      setFormData({ ...formData, modules: updatedModules });
                    }}
                    className="w-full p-2 border border-gray-300 rounded focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 h-16 resize-vertical text-sm"
                  />
                </div>
                
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">
                    Skills You'll Gain (one per line)
                  </label>
                  <textarea
                    placeholder="Skill 1&#10;Skill 2"
                    value={module.skillsYoullGain?.join('\n') || ''}
                    onChange={(e) => {
                      const updatedModules = [...formData.modules];
                      updatedModules[index] = { 
                        ...module, 
                        skillsYoullGain: e.target.value.split('\n').map(skill => skill.trim()).filter(skill => skill)
                      };
                      setFormData({ ...formData, modules: updatedModules });
                    }}
                    className="w-full p-2 border border-gray-300 rounded focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 h-16 resize-vertical text-sm"
                  />
                </div>
              </div>
            </div>
          ))}
          
          <button
            type="button"
            onClick={() => {
              const newModule = {
                title: '',
                duration: '',
                whatYoullLearn: { overview: '', objectives: [], byTheEnd: [] },
                skillsYoullGain: []
              };
              setFormData({ 
                ...formData, 
                modules: [...(formData.modules || []), newModule] 
              });
            }}
            className="w-full p-3 border-2 border-dashed border-gray-300 rounded-lg text-gray-600 hover:border-indigo-500 hover:text-indigo-600 transition-colors"
          >
            + Add Module
          </button>
        </div>
      </div>
    </div>
  )
        }

export default ProgramsForm;